export const NullValue = () => {
  return <span className="null-value opacity-50">NULL</span>
}
